import { TaxBenefitsResponse } from "types/Models/estimatedTax";

export const hasUploadedReturnForYear = (
  taxBenefits: TaxBenefitsResponse | undefined,
  taxYear: number
): boolean => Boolean(taxBenefits?.uploaded_return_years?.includes(taxYear));
